import React from 'react';
import SectionCard from '@/components/SectionCard';
import EditableImageBlock from './EditableImageBlock';
import EditableDetailsBlock from './EditableDetailsBlock';

interface TopicBasicsBlockProps {
  /**
   * The title field, which differs by path: `TitleBlock` for the per-type edit
   * forms, `TitleAndTypeBlock` (title + type chips) for the legacy `TopicView`.
   */
  titleBlock: React.ReactNode;
  imageData: string | null;
  onSelectFile: (file: File | null) => void;
  onClearImage: () => void;
  topicBody: string;
  setTopicBody: (value: string) => void;
  /** The body field's name and placeholder, e.g. "Article" for news. */
  bodyLabel?: string;
  bodyPlaceholder?: string;
}

/**
 * What every topic is, in one untitled card: its title, its representative image
 * and its body. These are the fields a topic cannot do without, so they
 * read as one group rather than three stacked cards — the titled cards below
 * ("When", "Visibility & limits") are the ones worth naming.
 */
const TopicBasicsBlock: React.FC<TopicBasicsBlockProps> = ({
  titleBlock,
  imageData,
  onSelectFile,
  onClearImage,
  topicBody,
  setTopicBody,
  bodyLabel,
  bodyPlaceholder,
}) => (
  <SectionCard>
    {titleBlock}
    <EditableImageBlock
      imageData={imageData}
      onSelectFile={onSelectFile}
      onClear={onClearImage}
    />
    <EditableDetailsBlock
      topicBody={topicBody}
      setTopicBody={setTopicBody}
      label={bodyLabel}
      placeholder={bodyPlaceholder}
    />
  </SectionCard>
);

export default TopicBasicsBlock;
